import type { OptionCategoryData } from "@hitit/api";
import { getKeyInTranslation } from "../../utils";
import OptionCategory from "./OptionCategory";
import type OptionItem from "./OptionItem";

export default class OptionCollection {
    public categories: OptionCategory[]
    public revision: number

    constructor(categories: OptionCategoryData[], revision: number) {
        const sorted = categories.sort((a, b) => a.displaySort - b.displaySort)
        const instances = sorted.map((v) => new OptionCategory(v))
        this.categories = instances
        this.revision = revision
    }

    public getNameIdItemLength() {
        return this.categories.map((v) => {
            return {
                uid: v.uid || "",
                id: v.getId() || "",
                translationDTO: v.getTranslations(),
                childrenLength: v.getOptions().length
            }
        })
    }

    public getCategories() {
        return [...this.categories]
    }

    public addNewCategory(category: OptionCategory) {
        this.categories = [...this.categories, category]
            .sort((a, b) => a.displaySort - b.displaySort)
    }

    public deleteCategory(category: OptionCategory) {
        this.categories = this.categories.filter(v => v !== category)
    }

    public deleteCategoryByUid(uid: string) {
        this.categories = this.categories.filter(v => v.uid !== uid)
    }

    public replaceCategoryById(id: string, category: OptionCategory) {
        this.categories = [
            ...this.categories.filter(v => v.getId() !== id),
            category
        ]
        return this.resoting()
    }
    public replaceCategoryByUid(uid: string, category: OptionCategory) {
        this.categories = [
            ...this.categories.filter(v => v.uid !== uid),
            category
        ]
        return this.resoting()
    }

    public resoting() {
        this.categories = this.categories
            .sort((a, b) => a.displaySort - b.displaySort)
            .map((v, i) => {
                v.displaySort = i;
                v.resorting()
                return v
            })
        return this
    }

    public findOption(search: string, lang = "ko") {
        const reg = new RegExp(search, "i");
        const items: OptionItem[] = [];

        for (const category of this.categories) {
            const optionItems = category.getOptions();

            for (const item of optionItems) {
                if (reg.test(getKeyInTranslation(item.translationDTOs, "name", lang) || "")) {
                    items.push(item)
                }
            }
        }
        return items
    }

    public findOptionByUid(uid: string) {
        return this.categories.find((v) => v.uid === uid)
    }
    public updateCategoryDisplaysort(oldIndex: number, newIndex: number) {
        if (oldIndex < newIndex) {
            this.categories.splice(newIndex + 1, 0, this.categories[oldIndex]);
            this.categories.splice(oldIndex, 1);
        } else {
            this.categories.splice(newIndex, 0, this.categories[oldIndex]);
            this.categories.splice(oldIndex + 1, 1);
        }

        const updatedCategories: { id: string, newDisplaySort: number }[] = [];

        for (let i = 0; i < this.categories.length; i++) {
            const target = this.categories[i];
            const updatedCategory = {
                id: target.getId() || "",
                newDisplaySort: i
            }

            if (target.displaySort !== i) updatedCategories.push(updatedCategory);
            target.displaySort = i;
        }
        this.resoting()

        return updatedCategories
    }
}